import { useEffect, useState } from 'react';
import { Box } from '@mui/material';

function TypewriterText({
  text = '',
  speed = 15, // ms per character
  startDelay = 0,
  onComplete,
  sx = {},
}) {
  const [displayed, setDisplayed] = useState('');

  useEffect(() => {
    let i = 0;

    let interval;

    setDisplayed('');

    const timeout = setTimeout(() => {
      interval = setInterval(() => {
        i += 1;

        setDisplayed(text.slice(0, i));

        if (i >= text.length) {
          clearInterval(interval);
          onComplete?.();
        }
      }, speed);
    }, startDelay);

    return () => {
      clearTimeout(timeout);
      clearInterval(interval);
    };
  }, [text, speed, startDelay]);

  return (
    <Box
      component="span"
      sx={{
        whiteSpace: 'pre-wrap',
        ...sx,
      }}>
      {displayed}
      <Cursor />
    </Box>
  );
}

function Cursor() {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-block',
        width: '8px',
        marginLeft: '2px',
        backgroundColor: 'currentColor',
        animation: 'blink 1s step-end infinite',
      }}
    />
  );
}

export default TypewriterText;
